
import { Component, Vue, Watch } from 'vue-property-decorator'

import BacLoggedInHeader from '@/templates/BacLoggedInHeader.vue'
import { Vehicle } from '../../lib/models/Vehicle'

@Component({
  components: {
    BacLoggedInHeader
  }
})
export default class VehicleSearch extends Vue {
  search = ''
  searchResults: Vehicle[] = []

  headers = [
    { text: 'ID', value: 'id', width: 30 },
    { text: 'Marke', value: 'brand', width: 80 },
    { text: 'Modell', value: 'type', width: 15 },
    { text: 'Baujahr', value: 'buildyear', width: 100 },
    { text: 'Kilometer', value: 'mileage', width: 30 },
    { text: 'PS', value: 'horsepower', width: 30 },
    { text: 'Preis', value: 'price', width: 30 },
    { text: 'Beschreibung', value: 'description', width: 30 },
    { text: 'Pannennotiz', value: 'breakdown', width: 30 },
    { text: 'Klassen', value: 'classesAsString', width: 30 }
  ]

  get items () {
    return this.searchResults.map(vehicle => {
      (vehicle as any).classesAsString = vehicle.classes.map(vehicleClass => {
        if (vehicleClass.class) {
          return vehicleClass.class.name
        }
      }).join(', ')
      return vehicle
    })
  }

  mounted () {
    this.searchVehicles()
  }

  async searchVehicles () {
    this.searchResults = await Vehicle.search(this.search)
  }

  private searchTimeout = 0;
  @Watch('search')
  onSearchChanged () {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout)
    }
    this.searchTimeout = setTimeout(this.searchVehicles, 500)
  }
}
